var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDream1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 60,
    viewBox: "0 0 72 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6724 42.1469C33.021 42.1469 37.0667 38.204 37.0667 29.6669C37.0667 21.1297 33.021 17.1869 27.6724 17.1869C22.3238 17.1869 18.3124 21.1297 18.3124 29.6669C18.3124 38.204 22.3238 42.1469 27.6724 42.1469ZM22.2895 29.6669C22.2895 23.2897 24.5524 20.3069 27.6724 20.3069C30.7924 20.3069 33.0552 23.2897 33.0552 29.6669C33.0552 36.044 30.7924 39.0269 27.6724 39.0269C24.5524 39.0269 22.2895 36.044 22.2895 29.6669Z",
    fill: "#680ADC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5311 17.2555L45.7082 20.7869H39.1597V23.9755H45.7082V41.6326H49.6511V17.2555H46.5311Z",
    fill: "#680ADC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.612244 7.347C0.612244 3.62752 3.62746 0.612305 7.34694 0.612305H15.9184V4.28577H7.34694C5.65627 4.28577 4.28571 5.65633 4.28571 7.347V15.9184H0.612244V7.347Z",
    fill: "#680ADC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4082 7.347C70.4082 3.62752 67.393 0.612305 63.6735 0.612305H55.1021V4.28577H63.6735C65.3641 4.28577 66.7347 5.65633 66.7347 7.347V15.9184H70.4082V7.347Z",
    fill: "#680ADC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4082 52.6531C70.4082 56.3726 67.393 59.3878 63.6735 59.3878H55.1021V55.7143H63.6735C65.3641 55.7143 66.7347 54.3437 66.7347 52.6531V44.0817H70.4082V52.6531Z",
    fill: "#680ADC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.612244 52.6531C0.612244 56.3726 3.62746 59.3878 7.34694 59.3878H15.9184V55.7143H7.34694C5.65627 55.7143 4.28571 54.3437 4.28571 52.6531V44.0817H0.612244V52.6531Z",
    fill: "#680ADC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDream1);
export default __webpack_public_path__ + "static/media/dream1.640c94fb81a3fb1d06f541002b9d76bf.svg";
export { ForwardRef as ReactComponent };